import { Navigate, useParams } from "react-router-dom";
import { getTutorialById } from "@/tutorials/tutorialRegistry";

export default function TutorialDemo() {
  const { tutorialId } = useParams();
  const tutorial = getTutorialById(tutorialId);
  const route = tutorial?.steps?.[0]?.route || "/settings/tutorials";
  return <Navigate to={route} replace />;
}
